/**
 * Split out UserAgent and Version number
 * @returns Browser UserAgent name without version number
 */
export default function userAgentVersion(): string {
  let endIndex = navigator.userAgent.length - 1;
  if (navigator.userAgent.indexOf("Chrome") != -1) {
    endIndex = navigator.userAgent.indexOf("Chrome");
  } else if (navigator.userAgent.indexOf("iPhone") != -1 && navigator.userAgent.indexOf("CriOS") != -1) {
    endIndex = navigator.userAgent.indexOf("CriOS");
  } else if (navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Version") != -1) {
    endIndex = navigator.userAgent.indexOf("Version");
  }
  return navigator.userAgent.substring(0, endIndex);
}

export function userAgentVersionBlank(): string {
  return "";
}
